<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Storefront</h4>
						<p class="card-category mb-0 storefront-layout-blurb">Dealer catalog, site content, QR codes, bestsellers, and new account approvals.</p>
					</div>
					<div class="card-body">
						<router-outlet></router-outlet>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
